export const isColorDark = (color: string): boolean => {
  if (color.includes('#')) {
    return isHashColorDark(color)
  }
  return isRGBAColorDark(color)
}

const isHashColorDark = (color: string): boolean => {
  // Remove any leading '#' from the color string
  color = color.replace(/^#/, '')

  // Convert the color to RGB format
  const r = parseInt(color.slice(0, 2), 16)
  const g = parseInt(color.slice(2, 4), 16)
  const b = parseInt(color.slice(4, 6), 16)

  // Calculate the relative luminance using the formula
  // Y = 0.299*R + 0.587*G + 0.114*B
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b

  // You can adjust this threshold as needed
  // Typically, a value around 128 is used to determine darkness or lightness
  return luminance < 128
}

const isRGBAColorDark = (rgbaColor: string): boolean => {
  // Extract the RGBA components
  const rgbaValues = rgbaColor.match(/(\d+(\.\d+)?)/g)

  if (rgbaValues && rgbaValues.length === 4) {
    const [r, g, b, alpha] = rgbaValues.map(Number)

    // Calculate the relative luminance using the formula Y = 0.299*R + 0.587*G + 0.114*B
    const luminance = 0.299 * r + 0.587 * g + 0.114 * b

    // You can adjust this threshold as needed
    // Typically, a value around 128 is used to determine darkness or lightness
    const isDark = luminance < 128

    // Check if the alpha channel is transparent (less than 1)
    const isTransparent = alpha < 1

    return isDark
  }

  if (rgbaValues && rgbaValues.length === 3) {
    const [r, g, b] = rgbaValues.map(Number)
    return isRGBColorDark(r, g, b)
  }

  // Return a default value or error indicator for invalid input
  return false
}

const isRGBColorDark = (r, g, b): boolean => {
  // Calculate the luminance
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b

  // If the luminance is less than or equal to 128 (0-255 scale), consider it as dark
  return luminance <= 128
}

export const calculateIsBackgroundColorDark = (className: string): boolean => {
  const containers = document.querySelectorAll(className)
  const container = containers[containers.length - 1]
  if (!container) return false
  const computedStyle = window.getComputedStyle(container)
  return isColorDark(computedStyle.backgroundColor)
}
